import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'cv-switch',
	templateUrl: './switch.component.html',
	styleUrls: ['./switch.component.scss']
})
export class SwitchComponent {
	@Input() disabled: boolean;
	@Input() checked: boolean;
	@Input() size: 'sm'|'md';
	@Input() class: 'primary'|'secondary'|'warning'|'success'|'danger'|'info'|'light'|'dark'|'default'|any;
	@Input() indexTab = 0;
	@Output() valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	constructor() {
		this.size            = 'md';
		this.class           = 'default';
	}

	/**
	 * On toggle switch, emit the change event of the curent value.
	 */
	onToggle(): void {
		if (!this.disabled) {
			this.valueChange.emit(!this.checked);
		}
	}
}
